export default __webpack_public_path__ + "static/media/facebook.7d8ad7d1.svg";